import { useState, useEffect } from 'react';

const API = 'https://tcio-api.onrender.com';

const money = (n) => '$' + Math.round(n || 0).toLocaleString('en-US');
const money2 = (n) => '$' + (parseFloat(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDate = (d) => {
  if (!d) return '—';
  try {
    const s = String(d).slice(0, 10);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const dt = m ? new Date(+m[1], +m[2]-1, +m[3]) : new Date(d);
    return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  catch { return '—'; }
};
const daysAgo = (n) => new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);
const today = () => new Date().toISOString().slice(0, 10);

const BUCKETS = {
  missing_from_bank: {
    key: 'missing_from_bank',
    icon: '🔴',
    title: 'Biller says paid — no money in the bank',
    action: 'Search the bank for these. If they never arrived, call the payer.',
    color: '#991b1b', bg: '#fef2f2', border: '#fecaca',
    amtField: 'zealie_amount',
  },
  missing_from_zealie: {
    key: 'missing_from_zealie',
    icon: '🟡',
    title: 'Money in the bank — Biller has no claim for it',
    action: 'Send to Biller to post against claims.',
    color: '#92400e', bg: '#fffbeb', border: '#fde68a',
    amtField: 'bank_amount',
  },
  variance: {
    key: 'variance',
    icon: '⚠️',
    title: 'Amounts do not match',
    action: 'Reconcile the difference with Biller.',
    color: '#9a3412', bg: '#fff7ed', border: '#fed7aa',
    amtField: 'variance',
  },
  matched: {
    key: 'matched',
    icon: '✅',
    title: 'Matched — nothing to do',
    action: 'Biller says paid, money is in the bank, amounts agree.',
    color: '#166534', bg: '#f0fdf4', border: '#bbf7d0',
    amtField: 'zealie_amount',
  },
};

const s = {
  bar: { display: 'flex', gap: 12, alignItems: 'flex-end', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '16px 20px', marginBottom: 18, flexWrap: 'wrap' },
  label: { fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 4, display: 'block' },
  input: { padding: '9px 12px', fontSize: 13, border: '1px solid #cbd5e1', borderRadius: 6, outline: 'none', color: '#1e293b' },
  runBtn: { padding: '10px 22px', background: '#336090', color: '#fff', border: 'none', borderRadius: 7, cursor: 'pointer', fontSize: 14, fontWeight: 700 },
  pdfBtn: { padding: '10px 18px', background: '#fff', color: '#336090', border: '1.5px solid #336090', borderRadius: 7, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  quick: { padding: '6px 12px', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 6, cursor: 'pointer', fontSize: 12, color: '#475569', fontWeight: 600 },

  topline: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 },
  toplineCard: { background: '#0f172a', borderRadius: 12, padding: '18px 22px', color: '#fff' },
  toplineLabel: { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', opacity: 0.6 },
  toplineBig: { fontSize: 30, fontWeight: 900, marginTop: 4, letterSpacing: '-0.5px' },

  tiles: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 18 },
  tile: (b, active) => ({
    background: active ? b.bg : '#fff',
    border: `2px solid ${active ? b.border : '#e2e8f0'}`,
    borderRadius: 10, padding: '14px 16px', cursor: 'pointer', textAlign: 'left',
  }),
  tileCount: (b) => ({ fontSize: 26, fontWeight: 800, color: b.color, lineHeight: 1 }),
  tileMoney: (b) => ({ fontSize: 15, fontWeight: 700, color: b.color, marginTop: 3 }),
  tileLabel: { fontSize: 10, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', marginTop: 6, lineHeight: 1.4 },

  panel: (b) => ({ background: '#fff', border: `1px solid ${b.border}`, borderRadius: 10, overflow: 'hidden', marginBottom: 18 }),
  panelHead: (b) => ({ background: b.bg, padding: '14px 20px', borderBottom: `1px solid ${b.border}` }),
  panelTitle: (b) => ({ fontSize: 14, fontWeight: 800, color: b.color }),
  panelAction: { fontSize: 12, color: '#64748b', marginTop: 3 },

  table: { width: '100%', borderCollapse: 'collapse' },
  th: { background: '#f8fafc', padding: '9px 14px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' },
  thR: { background: '#f8fafc', padding: '9px 14px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' },
  td: { padding: '9px 14px', fontSize: 13, color: '#334155', borderBottom: '1px solid #f1f5f9' },
  tdR: { padding: '9px 14px', fontSize: 13, color: '#334155', borderBottom: '1px solid #f1f5f9', textAlign: 'right', fontWeight: 700 },
  ref: { fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 12, color: '#0f172a', fontWeight: 600 },
  patients: { fontSize: 11, color: '#94a3b8', marginTop: 2, maxWidth: 340, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },

  empty: { padding: 34, textAlign: 'center', color: '#94a3b8', fontSize: 13 },
  note: { background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', borderRadius: 8, padding: '11px 14px', fontSize: 12, lineHeight: 1.55, marginBottom: 16 },
  warn: { background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 8, padding: '11px 14px', fontSize: 12, lineHeight: 1.55, marginBottom: 16 },
  err: { background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', borderRadius: 8, padding: '11px 14px', fontSize: 13, marginBottom: 16 },
};

export default function Reconciliation() {
  const [from, setFrom] = useState(daysAgo(90));
  const [to, setTo] = useState(today());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [open, setOpen] = useState('missing_from_bank');
  const [facilities, setFacilities] = useState([]);
  const [facilityId, setFacilityId] = useState('');
  useEffect(() => { (async () => {
    try {
      const r = await fetch(API + '/api/facilities', { headers: { Authorization: 'Bearer ' + localStorage.getItem('tcio_token') } });
      const j = await r.json();
      if (j.ok) { setFacilities(j.data); setFacilityId(prev => prev || ((j.data[0] || {}).id || '')); }
    } catch (e) {}
  })(); }, []);
  const facName = (facilities.find(f => f.id === facilityId) || {}).org_name || 'Facility';

  const token = () => localStorage.getItem('tcio_token');

  const run = async () => {
    setLoading(true); setErr(''); setData(null);
    try {
      const r = await fetch(`${API}/api/reconciliation/run?from=${from}&to=${to}&facilityId=${facilityId}`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      const j = await r.json();
      if (!j.ok) { setErr(j.error || 'Failed'); setLoading(false); return; }
      setData(j);
    } catch (e) { setErr('Connection error'); }
    setLoading(false);
  };

  const downloadPDF = () => {
    if (!data) return;
    const S = data.summary;
    const section = (b, rows) => {
      if (!rows.length) return '';
      return `
      <h2 style="color:${b.color};font-size:14px;margin:24px 0 4px;border-bottom:2px solid ${b.border};padding-bottom:5px">
        ${b.icon} ${b.title} — ${rows.length} item${rows.length === 1 ? '' : 's'}
      </h2>
      <p style="font-size:11px;color:#666;margin:4px 0 8px">${b.action}</p>
      <table style="width:100%;border-collapse:collapse;font-size:10px">
        <tr style="background:#f1f5f9">
          <th style="padding:5px;text-align:left;border:1px solid #e2e8f0">Date</th>
          <th style="padding:5px;text-align:left;border:1px solid #e2e8f0">Reference</th>
          <th style="padding:5px;text-align:left;border:1px solid #e2e8f0">Payer</th>
          <th style="padding:5px;text-align:right;border:1px solid #e2e8f0">Biller</th>
          <th style="padding:5px;text-align:right;border:1px solid #e2e8f0">Bank</th>
          <th style="padding:5px;text-align:right;border:1px solid #e2e8f0">Diff</th>
        </tr>
        ${rows.map(r => `
        <tr>
          <td style="padding:5px;border:1px solid #e2e8f0">${fmtDate(r.date)}</td>
          <td style="padding:5px;border:1px solid #e2e8f0;font-family:monospace">${r.ref || ''}</td>
          <td style="padding:5px;border:1px solid #e2e8f0">
            ${r.zealie_payers || r.payer || ''}
            ${r.patients ? `<div style="font-size:9px;color:#888;margin-top:2px">${String(r.patients).slice(0, 110)}</div>` : ''}
          </td>
          <td style="padding:5px;text-align:right;border:1px solid #e2e8f0">${money2(r.zealie_amount)}</td>
          <td style="padding:5px;text-align:right;border:1px solid #e2e8f0">${money2(r.bank_amount)}</td>
          <td style="padding:5px;text-align:right;border:1px solid #e2e8f0;color:${r.variance < 0 ? '#991b1b' : '#166534'}">${money2(r.variance)}</td>
        </tr>`).join('')}
      </table>`;
    };

    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>TCIO Reconciliation ${from} to ${to}</title></head>
<body style="font-family:Arial,sans-serif;padding:28px;color:#0f172a">
  <div style="border-bottom:3px solid #336090;padding-bottom:12px;margin-bottom:16px">
    <div style="font-size:20px;font-weight:800;color:#336090">PAYMENT RECONCILIATION</div>
    <div style="font-size:12px;color:#666;margin-top:3px">
      ${facName} · ${fmtDate(from)} – ${fmtDate(to)} · Generated ${fmtDate(today())}
    </div>
  </div>

  <table style="width:100%;font-size:12px;margin-bottom:14px">
    <tr>
      <td style="padding:8px;background:#f8fafc;border:1px solid #e2e8f0"><b>Biller says paid</b><br>
        <span style="font-size:17px;font-weight:800">${money2(S.zealie_total)}</span></td>
      <td style="padding:8px;background:#f8fafc;border:1px solid #e2e8f0"><b>Received in bank</b><br>
        <span style="font-size:17px;font-weight:800">${money2(S.bank_total)}</span></td>
      <td style="padding:8px;background:#fef2f2;border:1px solid #fecaca"><b>Unaccounted for</b><br>
        <span style="font-size:17px;font-weight:800;color:#991b1b">${money2(S.missing_from_bank_total)}</span></td>
    </tr>
  </table>

  <p style="font-size:11px;color:#555;line-height:1.6;background:#eff6ff;border:1px solid #bfdbfe;padding:9px;border-radius:5px">
    <b>How this is matched:</b> every payment is compared by its check or EFT reference number, not by payer name.
    All BCBS home plans (Hawaii, Michigan, Oklahoma, etc.) are remitted by Anthem Blue Cross California under the
    BlueCard program — one Anthem EFT can cover several home plans, so it is shown as a single payment.
    Blue Shield of California is a separate company and is matched on its own.
  </p>

  ${section(BUCKETS.missing_from_bank, data.missing_from_bank)}
  ${section(BUCKETS.missing_from_zealie, data.missing_from_zealie)}
  ${section(BUCKETS.variance, data.variance)}

  <p style="font-size:10px;color:#94a3b8;margin-top:26px;border-top:1px solid #e2e8f0;padding-top:8px">
    Generated by TCIO · Grayscale Technologies · Confidential — 42 CFR Part 2 ·
    ${S.matched_count} payments matched cleanly (${money2(S.matched_total)}) and are not listed.
  </p>
  <script>window.onload = () => window.print();</script>
</body></html>`;

    const w = window.open('', '_blank');
    w.document.write(html);
    w.document.close();
  };

  const S = data?.summary;

  return (
    <div>
      <div style={s.bar}>
        <div>
          <label style={s.label}>From</label>
          <input type="date" style={s.input} value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div>
          <label style={s.label}>To</label>
          <input type="date" style={s.input} value={to} onChange={e => setTo(e.target.value)} />
        </div>
        <button style={s.runBtn} onClick={run} disabled={loading}>
          {loading ? 'Reconciling…' : 'Run Reconciliation'}
        </button>
        {data && <button style={s.pdfBtn} onClick={downloadPDF}>⤓ Download PDF</button>}
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
          <button style={s.quick} onClick={() => { setFrom(daysAgo(30)); setTo(today()); }}>30d</button>
          <button style={s.quick} onClick={() => { setFrom(daysAgo(90)); setTo(today()); }}>90d</button>
          <button style={s.quick} onClick={() => { setFrom('2026-01-01'); setTo(today()); }}>YTD</button>
        </div>
      </div>

      <div style={{ marginBottom: 10 }}>
        <span style={s.label}>Facility</span>
        <select style={s.input} value={facilityId} onChange={e => setFacilityId(e.target.value)}>
          {facilities.map(f => <option key={f.id} value={f.id}>{f.org_name}</option>)}
        </select>
      </div>
      <div style={s.note}>
        <b>Matched on check / EFT reference — not payer name.</b> Every BCBS home plan (Hawaii, Michigan, Oklahoma…)
        is paid <i>by</i> Anthem Blue Cross California under BlueCard, so one Anthem EFT can cover several plans and
        shows here as a single payment. Blue Shield of California is a separate company and matches on its own.
      </div>

      {err && <div style={s.err}>{err}</div>}

      {!data && !loading && (
        <div style={{ ...s.empty, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10 }}>
          Pick a date range and run the reconciliation.
        </div>
      )}

      {S && (
        <>
          <div style={s.topline}>
            <div style={s.toplineCard}>
              <div style={s.toplineLabel}>Biller says paid</div>
              <div style={s.toplineBig}>{money(S.zealie_total)}</div>
            </div>
            <div style={{ ...s.toplineCard, background: S.missing_from_bank_total > 0 ? '#7f1d1d' : '#065f46' }}>
              <div style={s.toplineLabel}>Unaccounted for</div>
              <div style={s.toplineBig}>{money(S.missing_from_bank_total)}</div>
            </div>
          </div>

          {S.no_reference_count > 0 && (
            <div style={s.warn}>
              <b>{S.no_reference_count} bank payments ({money(S.no_reference_total)}) have no check or EFT reference logged.</b>{' '}
              They cannot be matched to a claim. Whoever logs incoming money needs to capture the reference number —
              it is the only thing that ties a deposit to a claim.
            </div>
          )}

          <div style={s.tiles}>
            {['missing_from_bank', 'missing_from_zealie', 'variance', 'matched'].map(k => {
              const b = BUCKETS[k];
              const count = S[`${k}_count`];
              const total = S[`${k}_total`];
              return (
                <div key={k} style={s.tile(b, open === k)} onClick={() => setOpen(open === k ? null : k)}>
                  <div style={s.tileCount(b)}>{count}</div>
                  <div style={s.tileMoney(b)}>{money(Math.abs(total))}</div>
                  <div style={s.tileLabel}>{b.icon} {b.title}</div>
                </div>
              );
            })}
          </div>

          {open && (() => {
            const b = BUCKETS[open];
            const rows = data[open] || [];
            return (
              <div style={s.panel(b)}>
                <div style={s.panelHead(b)}>
                  <div style={s.panelTitle(b)}>{b.icon} {b.title} — {rows.length}</div>
                  <div style={s.panelAction}>{b.action}</div>
                </div>
                {rows.length === 0 ? (
                  <div style={s.empty}>Nothing in this bucket.</div>
                ) : (
                  <table style={s.table}>
                    <thead>
                      <tr>
                        <th style={s.th}>Date</th>
                        <th style={s.th}>Check / EFT Reference</th>
                        <th style={s.th}>Payer &amp; Patients</th>
                        <th style={s.thR}>Biller</th>
                        <th style={s.thR}>Bank</th>
                        <th style={s.thR}>Difference</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.slice(0, 100).map((r, i) => (
                        <tr key={i}>
                          <td style={s.td}>{fmtDate(r.date)}</td>
                          <td style={s.td}><span style={s.ref}>{r.ref}</span></td>
                          <td style={s.td}>
                            {r.zealie_payers || r.payer}
                            {r.claims > 0 && <span style={{ color: '#94a3b8', fontSize: 11 }}> · {r.claims} claims</span>}
                            {r.patients && <div style={s.patients}>{r.patients}</div>}
                          </td>
                          <td style={s.tdR}>{r.zealie_amount ? money2(r.zealie_amount) : '—'}</td>
                          <td style={s.tdR}>{r.bank_amount ? money2(r.bank_amount) : '—'}</td>
                          <td style={{ ...s.tdR, color: r.variance < 0 ? '#991b1b' : r.variance > 0 ? '#166534' : '#94a3b8' }}>
                            {money2(r.variance)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {rows.length > 100 && (
                  <div style={{ ...s.empty, fontSize: 12 }}>
                    Showing 100 of {rows.length}. The PDF has all of them.
                  </div>
                )}
              </div>
            );
          })()}
        </>
      )}
    </div>
  );
}
